module.exports = __webpack_public_path__ + "static/media/homePerfection.fc22ceb9.jpg";